import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

import { CtaButtonComponent } from '@app/common/components/cta-button/cta-button.component';
import { ScrollService } from '@app/common/services/scroll.service';

@Component({
  selector: 'app-header',
  imports: [NgOptimizedImage, CtaButtonComponent, RouterLink],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  private router = inject(Router);
  private scrollService = inject(ScrollService);

  navigateToHomePage(): void {
    this.router.navigate(['/']).then(() => this.scrollService.scrollToTop());
  }
}
